import { Loop } from "@mui/icons-material";
import Button from "e.sic-platform.webclient/src/components/button/Button";
import useThemeService from 'e.sic-platform.webclient/src/services/theme-service/ThemeService';

export default function RedoButton(props: {disabled?: boolean, onClick?(): void}) {
  const { themeClass } = useThemeService();

  return (
    <Button
      id="redo"
      onClick={props.onClick}
      disabled={props.disabled}
      icon={{
        svg: Loop,
        textKey: "general.redo",
        textClass: "actions-header-button-label",
        className: themeClass(["icon-mui"]),
      }}
    />
  );
}
